import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/lib/uiScale";
import "@/lib/units";
import "@/lib/glove";
import "@/lib/a11y";
import "@/lib/decimalComma";
import { installPcHome } from "@/lib/pcHome";
installPcHome();
import { loadPdfFont } from "@/lib/pdfFont";
import { track } from "@/lib/funnel";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

loadPdfFont();
track('open');

const root = ReactDOM.createRoot(document.getElementById("root"));
if ('serviceWorker' in navigator) {
  // one service worker (and shell cache) per build so a new deploy never mixes old and new chunks
  const build = ([...document.scripts].map((x) => x.src).find((x) => /main\.[a-f0-9]+\.js/.test(x)) || '').match(/main\.([a-f0-9]+)/)?.[1] || 'dev';
  const hadSw = !!navigator.serviceWorker.controller;
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => { if (hadSw && !reloaded) { reloaded = true; window.location.reload(); } });
  window.addEventListener('load', () => navigator.serviceWorker.register(`/sw.js?v=${build}`).catch(() => {}));
  navigator.storage?.persist?.().catch(() => {});
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
